import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { useRequestListagem } from 'hooks/useRequestListagem';
import { RequestUsuariosListProps } from 'pages/cadastro/permissoes/types';

export function useQueryUsuarios({ query }: { query: string }) {
    const { limit, page, sort } = useListagemContext();
    const requestListagem = useRequestListagem();

    return useQuery<RequestUsuariosListProps>({
        queryKey: ['permissoes-usuarios', query, limit, page, sort],
        queryFn: () =>
            requestListagem({
                url: '/gestao/usuario',
                columns: 'idUsuario,dsUsuario',
                sort: sort.length ? sort : [{ property: 'dsUsuario', direction: 'ASC' }],
                limit,
                page,
                query,
            }).then((result) => result.data),
    });
}
